import { View, Text, FlatList, Image, TouchableOpacity, StyleSheet, Alert } from 'react-native';
import * as ImagePicker from 'expo-image-picker';
import { useAuth } from '@/hooks/useAuth';
import { useProgress } from '@/hooks/useProgress';
import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

export default function PhotosScreen() {
  const { profile } = useAuth();
  const [studentId, setStudentId] = useState('');
  const { photos, uploadPhoto } = useProgress(studentId);

  useEffect(() => {
    if (!profile) return;
    supabase.from('students').select('id').eq('profile_id', profile.id).single()
      .then(({ data }) => { if (data) setStudentId(data.id); });
  }, [profile]);

  async function handlePickPhoto() {
    const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
    if (status !== 'granted') { Alert.alert('Permissão necessária'); return; }
    const result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      quality: 0.8,
    });
    if (!result.canceled && result.assets[0]) {
      try {
        await uploadPhoto(result.assets[0].uri, studentId);
      } catch (e: any) {
        Alert.alert('Erro ao enviar foto', e.message);
      }
    }
  }

  return (
    <View style={styles.container}>
      <FlatList
        data={photos}
        keyExtractor={p => p.id}
        numColumns={2}
        renderItem={({ item }) => (
          <Image source={{ uri: item.photo_url }} style={styles.photo} />
        )}
        contentContainerStyle={{ padding: 8 }}
        ListEmptyComponent={<Text style={styles.empty}>Nenhuma foto ainda. Registre sua evolução!</Text>}
      />
      <TouchableOpacity style={styles.fab} onPress={handlePickPhoto}>
        <Text style={styles.fabText}>📷 Foto</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#F5F5F5' },
  photo: { flex: 1, margin: 4, aspectRatio: 1, borderRadius: 8, backgroundColor: '#eee' },
  empty: { textAlign: 'center', color: '#aaa', marginTop: 60, fontSize: 15 },
  fab: { position: 'absolute', bottom: 24, right: 24, backgroundColor: '#C8102E', paddingHorizontal: 20, paddingVertical: 14, borderRadius: 28, elevation: 4 },
  fabText: { color: '#fff', fontWeight: 'bold', fontSize: 15 },
});
